import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCta() {
  return <section id="contacto" className="py-24 bg-nova-gold relative overflow-hidden" data-id="element-90">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-91">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-92">
          <defs data-id="element-93">
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-94">
              <path d="M0 40L40 0H20L0 20M40 40V20L20 40" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-95" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" data-id="element-96" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-97">
        <div className="max-w-4xl mx-auto text-center" data-id="element-98">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-extrabold text-nova-navy-dark mb-6 leading-tight" data-id="element-99">
            ¿Listo para dejar de perder clientes en internet?
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-nova-navy-dark/80 font-medium mb-10 max-w-2xl mx-auto" data-id="element-100">
            Solicite su auditoría gratuita hoy. Analizaremos su presencia actual
            y le mostraremos exactamente cómo podemos mejorarla.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-101">
            <Button href="javascript:void(0)" className="bg-nova-navy-dark text-white hover:bg-nova-navy shadow-xl hover:shadow-2xl text-lg px-10 py-5" data-id="element-102">
              Solicitar Auditoría por WhatsApp
            </Button>
            <p className="mt-4 text-sm font-semibold text-nova-navy-dark/70" data-id="element-103">
              Respuesta en menos de 15 minutos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}